// Modules
import React from 'react';
import i18n from 'i18n-react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router-dom';

// Styling
import './navigation.scss';
const dateFormat = 'DD-MM-YYYY [om] HH:mm:ss';

const Navigation = (props) => {
    const { gitInfo } = props;
    return (
        <div className="side-navbar">
            <div className="logo" />
            <ul className={gitInfo ? 'navigation has-git-info' : 'navigation'}>
                <li className="navigation-item">
                    <Link className="navigation-label" to="/companies">
                        {i18n.translate('company.plural')}
                    </Link>
                </li>
                <li className="navigation-item">
                    <Link className="navigation-label" to="/administrations">
                        {i18n.translate('administration.plural')}
                    </Link>
                </li>
                <li className="navigation-item">
                    <Link className="navigation-label" to="/templates">
                        {i18n.translate('template.plural')}
                    </Link>
                </li>
                <li className="navigation-item">
                    <Link className="navigation-label" to="/jobs">
                        {i18n.translate('jobs.plural')}
                    </Link>
                </li>
                <li className="navigation-item">
                    <Link className="navigation-label" to="/paco">
                        {i18n.translate('paco.short')}
                    </Link>
                </li>
            </ul>
            {gitInfo && (
                <div className="git-info">
                    <div className="info">
                        <div className="title">{i18n.translate('gitInfo.version')}</div>
                        <div>{gitInfo.version}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    gitInfo: state.appData.gitInfo,
});

export default connect(mapStateToProps)(Navigation);
